import * as tslib_1 from "tslib";
import React from 'react';
import Typography from 'sinoui-components/Typography';
import paddingPropReceiver from 'sinoui-components/styled-components-utils/prop-receivers/padding';
import { connect } from 'formik';
var VerticalAlignMap = {
    center: 'center',
    top: 'flex-start',
    bottom: 'flex-end',
};
export var FormTextWrapper = Typography.extend.attrs({
    type: 'subheading',
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex: 1;\n  align-items: ", ";\n  ", ";\n  ", ";\n  padding: 4px 0;\n  flex: 1;\n"], ["\n  display: flex;\n  flex: 1;\n  align-items: ", ";\n  ",
    ";\n  ", ";\n  padding: 4px 0;\n  flex: 1;\n"])), function (props) { return VerticalAlignMap[props.verticalAlign || 'center']; }, function (props) {
    return props.line > 0 &&
        "\n    height: " + props.line * 48 + "px;\n    overflow: auto;\n  ";
}, paddingPropReceiver);
var FormText = function (_a) {
    var prefix = _a.prefix, subfix = _a.subfix, name = _a.name, text = _a.text, contentStyle = _a.contentStyle, formik = _a.formik, props = tslib_1.__rest(_a, ["prefix", "subfix", "name", "text", "contentStyle", "formik"]);
    return (React.createElement(FormTextWrapper, tslib_1.__assign({}, props),
        prefix,
        React.createElement("div", { style: contentStyle }, text || (name ? formik.values[name] : props.children)),
        subfix));
};
export default connect(FormText);
var templateObject_1;
//# sourceMappingURL=FormText.js.map